import React from 'react';
import { ToastContainer } from 'react-toastify';
import AdminChrome from '../../AdminShared/AdminChrome';
import NavigationTypeEditor from '../components/NavigationTypeEditor';

const NavigationTypeEditorApp = ({ chrome = {}, ...props }) => (
  <AdminChrome {...chrome}>
    <div className="adash-body">
      <NavigationTypeEditor {...props} />
    </div>
    <ToastContainer icon={false} />
  </AdminChrome>
);

export default NavigationTypeEditorApp;
